function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "41gzq7ga2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-building-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon-building-mono (Background/Mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#41gzq7ga2a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.336 14.059H.8a.794.794 0 0 1-.565-.234.8.8 0 0 1-.235-.566V.667A.666.666 0 0 1 .667 0h10a.671.671 0 0 1 .471.2.663.663 0 0 1 .2.472v12.587a.806.806 0 0 1-.235.566.8.8 0 0 1-.566.234H7v-2.5a.666.666 0 0 0-.667-.667H5a.671.671 0 0 0-.472.2.664.664 0 0 0-.195.472v2.5zM7.738 7.4v1.2h1.2V7.4zm-2.668 0v1.2h1.2V7.4zm-2.67 0v1.2h1.2V7.4zm5.338-2.5v1.2h1.2V4.9zm-2.668 0v1.2h1.2V4.9zm-2.67 0v1.2h1.2V4.9zm5.338-2.5v1.2h1.2V2.4zm-2.668 0v1.2h1.2V2.4zm-2.67 0v1.2h1.2V2.4z",
    transform: "translate(2.331 1)",
    style: {
      fill: "#232323"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCompany);
export default __webpack_public_path__ + "static/media/ico_company.0b0384d10d12f4f086195f9b9146e9cb.svg";
export { ForwardRef as ReactComponent };